// extracted by mini-css-extract-plugin
export default {"Container":"planning_Container__Uwy-U","section-1":"planning_section-1__Uz26N","content":"planning_content__PscwS","section-2":"planning_section-2__YDHOo"};